// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";

function toString(transactionType) {
  if (transactionType) {
    return "DEBIT";
  } else {
    return "CREDIT";
  }
}

function fromString(transactionTypeString) {
  switch (transactionTypeString) {
    case "CREDIT" :
        return /* Credit */0;
    case "DEBIT" :
        return /* Debit */1;
    default:
      return Pervasives.failwith("TransactionType.re - Invalid transaction type found " + transactionTypeString);
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
